import { useStore } from './state/store';
import { Header } from './components/Header';
import { WorkspaceCanvas } from './components/WorkspaceCanvas';
import { AiPanel } from './components/AiPanel';
import { Terminal } from './components/Terminal';
import { SettingsModal } from './components/SettingsModal';
import { CodeModal } from './components/CodeModal';
import { LoginPage } from './components/LoginPage';
import { HomePage } from './components/HomePage';
import { AdminView } from './components/AdminView';
import { OrgView } from './components/OrgView';

export function App() {
  const user = useStore((s) => s.auth.user);
  const view = useStore((s) => s.view);
  const aiOpen = useStore((s) => s.aiOpen);

  if (!user) {
    return <LoginPage />;
  }

  // Members never reach administrative surfaces, even with a stale view state.
  if (view === 'admin' && !user.isAdmin) {
    return <HomePage />;
  }

  if (view === 'org' && user.role !== 'org_admin' && user.role !== 'org_manager') {
    return <HomePage />;
  }

  if (view === 'home') {
    return <HomePage />;
  }

  if (view === 'admin') {
    return <AdminView />;
  }

  if (view === 'org') {
    return <OrgView />;
  }

  return (
    <div className={`app ${aiOpen ? '' : 'ai-collapsed'}`}>
      <Header />
      <WorkspaceCanvas />
      <AiPanel />
      <Terminal />
      <SettingsModal />
      <CodeModal />
    </div>
  );
}
